import React, {Dispatch, SetStateAction} from 'react';
import CloseButton from './CloseButton';
import BISSELLNotice from './BISSELLNotice';
interface ModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  noticeId: string;
  locale: string;
}

declare global {
  interface Window {
    BISSELLNotice?: (options: BISSELLNoticeOptions) => void;
  }
}

interface BISSELLNoticeOptions {
  entryId: string;
  sidebar: boolean;
  locale: string;
  fallbackLocale?: string;
}

const TermsModal: React.FC<ModalProps> = ({
  isOpen,
  setIsOpen,
  noticeId,
  locale,
}) => {
  if (!isOpen) return null;

  return (
    <div className='flex justify-center h-screen bg-gray-500'>
      <div className='fixed z-10 inset-y-10 overflow-y-scroll justify-center w-11/12'>
        <div className='bg-white rounded-lg z-50 mt-0 pt-5 self-center w-auto'>
          <CloseButton onClose={() => setIsOpen(false)} />
          {BISSELLNotice({
            entryId: noticeId,
            sidebar: true,
            locale: locale,
          })}
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
